import React, { useState } from "react";
import "./MovingHeadline.css";
import { Bell, X } from "lucide-react";

const MovingHeadline = () => {
  const [visible, setVisible] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);

  return (
    <div className="headline-container">
      {visible ? (
        <div className="headline-bar">
          <div className="headline-text">
            <span>
              🏆 Fitoja Weight Loss Challenge! Lose 7 KG in 1 Month & Get a Silver
              Coin!
            </span>
          </div>
          <button className="close-btn" onClick={() => setVisible(false)}>
            <X size={20} />
          </button>
        </div>
      ) : (
        <div className="notification-icon" onClick={() => setShowOverlay(true)}>
          <Bell size={28} />
          <span className="badge">1</span>
        </div>
      )}

      {showOverlay && (
        <div className="notification-overlay">
          <div className="overlay-content">
            <div className="overlay-header">
              <span>🏆 Weight Loss Challenge!</span>
              <button
                className="overlay-close-btn"
                onClick={() => setShowOverlay(false)}
              >
                <X size={18} />
              </button>
            </div>
            <p>Lose 7 KG in 1 Month & Get a Silver Coin 🎁</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default MovingHeadline;
